"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.START_POSITION = exports.JUSTIFY = exports.DIRECTION = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.common");

require("./InlineComponents.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Stateless component to draw an image
 * @param {node} children array of items like: {svgId, label, labelPosition}
 * @param {string} start flex-start ( like flex )
 * @param {bool} multiline flexx-wrap (Flex) allow content drop to a second line
 * @param {string} direction row | column (flex)
 * @param {string} justify betwwen or evenly (Flex)
 * @returns {JSX} render a collection of react components wrap by flex.
 */
const START_POSITION = {
  START: 'flex-start',
  END: 'flex-end',
  CENTER: 'center',
  BASELINE: 'baseline'
};
exports.START_POSITION = START_POSITION;
const DIRECTION = {
  ROW: 'row',
  COLUMN: 'column',
  ROW_REVERSE: 'rowreverse',
  COLUMN_REVERSE: 'columnreverse'
};
exports.DIRECTION = DIRECTION;
const JUSTIFY = {
  BETWEEN: 'between',
  EVENLY: 'evenly',
  AROUND: 'around',
  NORMAL: 'normal',
  CENTER: 'center'
};
exports.JUSTIFY = JUSTIFY;

const InlineComponents = props => {
  const myProps = (0, _gerenciatdUtils.setUpPropsByDevice)(props);
  const {
    children,
    wrap,
    direction,
    justify,
    className,
    startPosition
  } = myProps;
  /* inlineStyles */

  const multilineCss = multilineAux => {
    switch (multilineAux) {
      case 'no-wrap':
        return ' inlineComponents--singleline';

      default:
        return ' inlineComponents--multiline';
    }
  };

  const directionCss = directionAux => {
    switch (directionAux) {
      case 'column':
        return ' inlineComponents--column';

      case 'rowreverse':
        return ' inlineComponents--rowreverse';

      case 'columnreverse':
        return ' inlineComponents--columnreverse';

      default:
        return ' inlineComponents--row';
    }
  };

  const startCss = startAux => {
    switch (startAux) {
      case 'flex-start':
        return ' inlineComponents--start';

      case 'flex-end':
        return ' inlineComponents--end';

      case 'baseline':
        return ' inlineComponents--baseline';

      default:
        return ' inlineComponents--center';
    }
  };

  const justifyCss = justifyAux => {
    switch (justifyAux) {
      case 'between':
        return ' inlineComponents--justifybetween';

      case 'evenly':
        return ' inlineComponents--justifyevenly';

      case 'around':
        return ' inlineComponents--justifyaround';

      case 'center':
        return ' inlineComponents--justifycenter';

      default:
        return ' inlineComponents--justifynormal';
    }
  };

  const cssLabel = `inlineComponents${multilineCss(wrap)}${directionCss(direction)}${justifyCss(justify)}${startCss(startPosition)}`;
  const ownCss = className ? `${className} ${cssLabel}` : cssLabel;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: ownCss,
    children: children
  });
};

InlineComponents.propTypes = {
  /**
   * {
   *  "info": "Define la clase CSS custom que se aplicará al componente",
   *  "kind": "both",
   *  "beautifulName": "Estilos custom"
   * }
   */
  className: _propTypes.default.string,

  /**
   * {
   *  "info": "Array de elementos que forman el componente",
   *  "kind": "both",
   *  "beautifulName": "Elememtos del componente"
   * }
   */
  children: _propTypes.default.node.isRequired,

  /**
   * {
   *  "info": "Establece si los elementos del listados son o no multilinea",
   *  "kind": "both",
   *  "beautifulName": "Multilinea"
   * }
   */
  wrap: _propTypes.default.bool,

  /**
   * {
   *  "info": "Establece el alineamiento del primer elemento respecto a la vertical",
   *  "kind": "both",
   *  "beautifulName": "Alineación vertical"
   * }
   */
  startPosition: _propTypes.default.oneOf([START_POSITION.START, START_POSITION.END, START_POSITION.CENTER, START_POSITION.BASELINE]),

  /**
   * {
   *  "info": "Establece la dirección de los elementos del listado para que se comporten como filas o columna",
   *  "kind": "both",
   *  "beautifulName": "Dirección"
   * }
   */
  direction: _propTypes.default.oneOf([DIRECTION.COLUMN, DIRECTION.ROW, DIRECTION.REVERSE]),

  /**
   * {
   *  "info": "Establece como se distribuye el espacio alrededor de los elementos",
   *  "kind": "both",
   *  "beautifulName": "Justificado"
   * }
   */
  justify: _propTypes.default.oneOf([JUSTIFY.NORMAL, JUSTIFY.BETWEEN, JUSTIFY.EVENLY, JUSTIFY.AROUND, JUSTIFY.CENTER])
};
InlineComponents.defaultProps = {
  className: '',
  wrap: true,
  startPosition: START_POSITION.CENTER,
  direction: DIRECTION.ROW,
  justify: JUSTIFY.NORMAL
};
var _default = InlineComponents;
exports.default = _default;

//# sourceMappingURL=index.js.map